module.exports = __webpack_public_path__ + "b2015bd99c07b1d3a84b6ee9dc4e71ff.svg";